/* Custom Review STH
   Interactions: write-review panel, star rating, filters, sorting. */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.customReviewSthReady === 'true') return;
    root.dataset.customReviewSthReady = 'true';

    setupFormPanel(root);
    setupStars(root);
    setupUploadPreview(root);
    setupFilters(root);
  }

  /* ---------- Write a review panel ---------- */

  function setupFormPanel(root) {
    var toggle = root.querySelector('[data-custom-review-sth-form-toggle]');
    var panel = root.querySelector('[data-custom-review-sth-form-panel]');
    var close = root.querySelector('[data-custom-review-sth-form-close]');
    if (!toggle || !panel) return;

    function open(state) {
      panel.hidden = !state;
      toggle.setAttribute('aria-expanded', String(state));
      if (state) {
        var first = panel.querySelector('button, input, textarea, select');
        if (first) first.focus();
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      open(panel.hidden);
    });

    if (close) {
      close.addEventListener('click', function () { open(false); });
    }

    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') open(false);
    });
  }

  /* ---------- Star rating (radiogroup) ---------- */

  function setupStars(root) {
    var group = root.querySelector('[data-custom-review-sth-stars]');
    var input = root.querySelector('[data-custom-review-sth-stars-input]');
    if (!group || !input) return;

    var buttons = Array.prototype.slice.call(group.querySelectorAll('.custom-review-sth-stars__btn'));

    function paint(value, persist) {
      buttons.forEach(function (button, index) {
        var on = index < value;
        button.textContent = on ? '★' : '☆';
        button.classList.toggle('is-on', on);
        if (persist) {
          button.setAttribute('aria-checked', String(index + 1 === value));
          button.tabIndex = index + 1 === value ? 0 : -1;
        }
      });
    }

    function select(value) {
      input.value = String(value);
      paint(value, true);
    }

    buttons.forEach(function (button, index) {
      button.tabIndex = index === 0 ? 0 : -1;

      button.addEventListener('click', function () {
        select(index + 1);
      });

      button.addEventListener('mouseenter', function () {
        paint(index + 1, false);
      });

      button.addEventListener('keydown', function (event) {
        var current = parseInt(input.value, 10) || 0;
        var next = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next = Math.min(current + 1, 5);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next = Math.max(current - 1, 1);
        if (event.key === ' ' || event.key === 'Enter') next = index + 1;

        if (next) {
          event.preventDefault();
          select(next);
          buttons[next - 1].focus();
        }
      });
    });

    group.addEventListener('mouseleave', function () {
      paint(parseInt(input.value, 10) || 0, false);
    });
  }

  /* ---------- Photo upload preview ---------- */

  function setupUploadPreview(root) {
    var input = root.querySelector('[data-custom-review-sth-upload]');
    var preview = root.querySelector('[data-custom-review-sth-upload-preview]');
    if (!input || !preview) return;

    input.addEventListener('change', function () {
      preview.innerHTML = '';
      Array.prototype.slice.call(input.files, 0, 3).forEach(function (file) {
        var image = document.createElement('img');
        image.alt = file.name;
        image.src = URL.createObjectURL(file);
        image.addEventListener('load', function () { URL.revokeObjectURL(image.src); });
        preview.appendChild(image);
      });
    });
  }

  /* ---------- Filtering and sorting ---------- */

  function setupFilters(root) {
    var list = root.querySelector('[data-custom-review-sth-review-list]');
    if (!list) return;

    var reviews = Array.prototype.slice.call(list.querySelectorAll('[data-custom-review-sth-review]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-custom-review-sth-filter]'));
    var productSelect = root.querySelector('[data-custom-review-sth-filter-product]');
    var sortSelect = root.querySelector('[data-custom-review-sth-sort]');
    var empty = root.querySelector('[data-custom-review-sth-empty]');

    var state = { quick: 'all', product: 'all', sort: 'recent' };

    function matches(review) {
      var rating = parseInt(review.dataset.rating, 10) || 0;
      var hasPhotos = review.dataset.photos === 'true';
      var product = review.dataset.product || '';

      if (state.quick === '5' && rating !== 5) return false;
      if (state.quick === '4' && rating !== 4) return false;
      if (state.quick === 'photos' && !hasPhotos) return false;
      if (state.product !== 'all' && product !== state.product) return false;

      return true;
    }

    function apply() {
      var visible = 0;

      reviews.forEach(function (review) {
        var show = matches(review);
        review.hidden = !show;
        if (show) visible += 1;
      });

      var ordered = reviews.slice().sort(function (a, b) {
        if (state.sort === 'highest') {
          return (b.dataset.rating - a.dataset.rating) || (a.dataset.index - b.dataset.index);
        }
        if (state.sort === 'lowest') {
          return (a.dataset.rating - b.dataset.rating) || (a.dataset.index - b.dataset.index);
        }
        var byDate = (parseInt(b.dataset.timestamp, 10) || 0) - (parseInt(a.dataset.timestamp, 10) || 0);
        return byDate || (a.dataset.index - b.dataset.index);
      });

      ordered.forEach(function (review) { list.appendChild(review); });

      if (empty) empty.hidden = visible !== 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.quick = chip.dataset.customReviewSthFilter;
        chips.forEach(function (other) {
          other.setAttribute('aria-pressed', String(other === chip));
        });
        apply();
      });
    });

    if (productSelect) {
      productSelect.addEventListener('change', function () {
        state.product = productSelect.value;
        apply();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        apply();
      });
    }

    apply();
  }

  /* ---------- Boot ---------- */

  function boot() {
    document.querySelectorAll('[data-custom-review-sth-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-initialise after a section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-custom-review-sth-reviews]').forEach(init);
  });
})();
